import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function BlackWhite(props) {
  return (
    <SvgIcon
      viewBox="0 0 83.81 92.47" // Adjust this if needed for proportional scaling
      style={{ width: props.width || '48px', height: props.height || '48px' }} // Default size set here
    >
     
     <path  
     d="M17.35,55.08c0-12,.02-24.01-.03-36.01,0-1.16.22-1.55,1.48-1.54,7.2.07,14.41.06,21.61,0,1.16,0,1.43.3,1.43,1.44-.04,24.01-.04,48.02,0,72.03,0,1.29-.23,1.71-1.64,1.69-7.15-.09-14.3-.07-21.45-.01-1.17,0-1.42-.31-1.42-1.44.04-12.06.03-24.11.03-36.17Z"
     fill="black"

    />
 
    <path 
     d="M43.86,86.26c0-1.17,0-2.17,0-3.18,0-14.61,0-29.21-.02-43.82,0-1.06.25-1.97.79-2.88,2.3-3.91,4.55-7.84,6.79-11.78.4-.7.66-1.07,1.59-.53,6.41,3.77,12.85,7.49,19.3,11.17.77.44.84.73.41,1.47-9.51,16.44-19.01,32.89-28.51,49.34-.02.04-.09.05-.36.2Z"
     fill="black"

     />
 
  <path  
    d="M43.96,90.64c3.17-5.5,6.34-11.01,9.52-16.51,4.71-8.15,9.43-16.3,14.13-24.46.37-.64.81-1.12,1.46-1.49,3.1-1.75,6.19-3.53,9.27-5.33.62-.36.94-.49,1.39.29,3.73,6.54,7.49,13.07,11.3,19.56.56.95-.03,1.11-.6,1.43-10.1,5.83-20.19,11.65-30.29,17.48-5.33,3.08-10.66,6.15-15.98,9.23-.06-.07-.13-.13-.19-.2Z"
    fill="black"

    />

  <path 
   d="M29.51,86.95c-3.06-.02-5.5-2.47-5.52-5.53-.01-3.03,2.46-5.56,5.47-5.59,3.06-.03,5.64,2.56,5.62,5.63-.02,3.01-2.56,5.51-5.57,5.5Z"
   fill="white"
   />

  <path 
   d="M29.58,77.92c1.92.03,3.46,1.62,3.42,3.54-.04,1.9-1.64,3.46-3.54,3.46-1.81,0-3.52-1.77-3.46-3.57.05-1.87,1.72-3.45,3.59-3.42Z"
   fill='black'

   />

    </SvgIcon>
  );
}
